export default __webpack_public_path__ + "static/media/success_true_tick.25ed5cbe.svg";